// extracted by mini-css-extract-plugin
module.exports = {"root":"CarSpinAnimation_root__sbNVn","caption":"CarSpinAnimation_caption__HsWU1","animation":"CarSpinAnimation_animation__oFlaa"};